import { Link } from "react-router-dom";
import { useEnv } from "@/hooks/useEnv";

export default function TermsPage() {
  const { contactEmail } = useEnv();

  const sections = [
    {
      title: "1. Предмет соглашения",
      content: `Настоящее Пользовательское соглашение (далее — «Соглашение») определяет общие условия использования сервиса BroMoney (далее — «Сервис», «мы») физическими лицами (далее — «Пользователь»).

BroMoney предоставляет удобный инструмент для проведения онлайн-операций с электронными средствами: переводы, конвертация, пополнение и выплаты. Используя Сервис, вы подтверждаете, что ознакомились с настоящим Соглашением и принимаете его условия.

Мы можем периодически обновлять условия Соглашения. Актуальная версия всегда доступна на сайте.`,
    },
    {
      title: "2. Условия доступа к сервису",
      content: `Для использования BroMoney Пользователь должен соответствовать следующим условиям:

— Быть физическим лицом в возрасте не менее 18 лет;
— Предоставить корректные данные при регистрации;
— Использовать Сервис добросовестно и в соответствии с его назначением;
— Самостоятельно обеспечивать сохранность данных доступа к аккаунту.

Компания вправе ограничить доступ к Сервису по усмотрению администрации, не раскрывая конкретных оснований.`,
    },
    {
      title: "3. Регистрация и подтверждение личности",
      content: `Для полноценного использования функций BroMoney может потребоваться подтверждение личности Пользователя.

**Базовый уровень:** подтверждение электронной почты и номера телефона.

**Стандартный уровень:** предоставление копии документа, удостоверяющего личность, и фотографии (селфи).

**Расширенный уровень:** при необходимости могут быть запрошены дополнительные документы или сведения.

Решение о принятии документов и присвоении уровня доступа принимается Сервисом самостоятельно.`,
    },
    {
      title: "4. Операции в сервисе",
      content: `BroMoney позволяет Пользователям совершать следующие операции:

— Пополнение счёта через доступные способы приёма средств;
— Вывод средств на подключённые реквизиты;
— Переводы между участниками Сервиса;
— Конвертация по внутреннему курсу Сервиса;
— Оплата услуг и сервисов у партнёров.

Сроки обработки операций могут варьироваться в зависимости от используемого метода. Сервис не несёт ответственности за задержки по причинам, не зависящим от нас.

Подтверждённые операции могут считаться окончательными по усмотрению Сервиса.`,
    },
    {
      title: "5. Тарифы и комиссии",
      content: `Актуальные тарифы BroMoney публикуются в личном кабинете и на официальном сайте. Мы можем изменять тарифы, заблаговременно уведомив Пользователей об изменениях.

Комиссия применяется в момент проведения операции. Нажимая «Подтвердить», Пользователь соглашается с применяемым тарифом.

Дополнительные расходы на стороне принимающей системы или банка остаются вне зоны ответственности BroMoney.`,
    },
    {
      title: "6. Ограничения и лимиты",
      content: `Сервис устанавливает операционные лимиты, которые зависят от уровня подтверждения аккаунта Пользователя.

— Суточные и месячные ограничения на ввод и вывод;
— Ограничения по отдельным методам;
— Иные лимиты, вводимые по усмотрению Сервиса.

Для увеличения лимитов Пользователю необходимо пройти более высокий уровень верификации. Актуальные ограничения отображаются в личном кабинете.`,
    },
    {
      title: "7. BroMoney Peer-to-Peer (P2P)",
      content: `BroMoney P2P — это инструмент для прямых сделок между участниками Сервиса без участия третьих сторон. P2P-площадка позволяет Пользователям размещать объявления о покупке или продаже электронных средств на согласованных условиях.

**Как работает P2P:**

— Продавец размещает объявление с указанием суммы, способа оплаты и условий сделки;
— Покупатель выбирает подходящее объявление и инициирует сделку;
— Средства продавца блокируются Сервисом на время исполнения;
— После подтверждения получения оплаты средства перечисляются покупателю.

**Гарантийное хранение (escrow):**

BroMoney выступает нейтральным хранителем средств на время P2P-сделки. Средства не перечисляются до момента подтверждения обеими сторонами. Если одна из сторон не выполняет условия, Пользователь вправе открыть спор.

**Условия участия:**

— Участие в P2P доступно Пользователям с подтверждённым аккаунтом;
— Пользователь несёт ответственность за достоверность указанных условий сделки;
— Запрещено использовать P2P для обхода ограничений Сервиса или введения другой стороны в заблуждение.

**Споры по P2P-сделкам:**

— Спор может быть инициирован любой из сторон в течение установленного времени;
— Сервис изучает доступные материалы и выносит решение в разумные сроки;
— Решение Сервиса по споруявляется окончательным.

**Комиссии P2P:**

Актуальные комиссии за P2P-сделки указаны в разделе тарифов личного кабинета. Сервис не взимает скрытых платежей.`,
    },
    {
      title: "8. Безопасность аккаунта",
      content: `Пользователь самостоятельно обеспечивает безопасность своей учётной записи. Рекомендуется:

— Использовать надёжный уникальный пароль;
— Включить двухфакторную аутентификацию;
— Не передавать данные доступа третьим лицам;
— При подозрении на несанкционированный доступ незамедлительно обратиться в поддержку: ${contactEmail}.

BroMoney применяет современные технологии защиты данных и транзакций.`,
    },
    {
      title: "9. Ограничение доступа к аккаунту",
      content: `Сервис вправе временно ограничить или приостановить доступ к аккаунту в следующих случаях:

— Нарушение условий Соглашения;
— Подозрение в использовании Сервиса не по назначению;
— Несоответствие предоставленных данных;
— Длительная неактивность аккаунта (свыше 24 месяцев).

В большинстве случаев Пользователь получает уведомление по электронной почте. Средства на заблокированном счёте остаются сохранными и могут быть выданы после урегулирования ситуации.`,
    },
    {
      title: "10. Ответственность",
      content: `BroMoney прилагает разумные усилия для бесперебойной работы Сервиса и сохранности средств Пользователей.

Сервис не несёт ответственности за:

— Действия третьих сторон или технические сбои на их стороне;
— Форс-мажорные обстоятельства, повлиявшие на доступность Сервиса;
— Последствия несоблюдения Пользователем правил безопасности;
— Косвенный ущерб или упущенную выгоду.`,
    },
    {
      title: "11. Расторжение",
      content: `Пользователь может закрыть аккаунт в любое время, направив запрос на ${contactEmail}. Рекомендуется заблаговременно вывести все средства.

Сервис может прекратить предоставление услуг конкретному Пользователю при систематических нарушениях Соглашения.`,
    },
    {
      title: "12. Споры и обратная связь",
      content: `В случае возникновения вопросов или несогласий с действиями Сервиса, Пользователь может направить обращение на ${contactEmail}.

Мы стремимся рассмотреть каждое обращение в разумные сроки и найти взаимоприемлемое решение.`,
    },
    {
      title: "13. Контактная информация",
      content: `Email: ${contactEmail}
Сайт: bromoney.net

Служба поддержки доступна 24/7. Среднее время ответа — до 4 часов.`,
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <div className="bg-[#f8fafd] border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 py-12">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#007AFF] text-sm font-medium mb-6 hover:opacity-80 transition-opacity cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            На главную
          </Link>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 flex items-center justify-center bg-[#007AFF]/10 rounded-xl">
              <i className="ri-file-text-line text-[#007AFF] text-xl" />
            </div>
            <span className="text-[#007AFF] text-sm font-semibold uppercase tracking-wide">BroMoney</span>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-3">Пользовательское соглашение</h1>
          <p className="text-gray-400 text-sm">Последнее обновление: 1 января 2025 года</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-14">
        <div className="bg-[#eff6ff] border border-[#c7dcff] rounded-xl px-6 py-4 mb-10">
          <p className="text-[#007AFF] text-sm leading-relaxed">
            <strong>Обратите внимание:</strong> Используя сервис BroMoney, вы подтверждаете, что ознакомились с настоящим Соглашением и принимаете его условия.
          </p>
        </div>

        <div className="flex flex-col gap-10">
          {sections.map((sec) => (
            <div key={sec.title}>
              <h4 className="text-lg font-bold text-gray-900 mb-3">
                <a
                  id={sec.title.toLowerCase().replace(/\s+/g, "-")}
                  href={`#${sec.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="hover:text-[#007AFF] transition-colors"
                >
                  {sec.title}
                </a>
              </h4>
              <div className="text-gray-500 text-[15px] leading-relaxed">
                {sec.content.split("\n").map((line, idx) => {
                  if (line.startsWith("**") && line.endsWith("**")) {
                    return (
                      <p key={idx} className="font-semibold text-gray-700 mt-3 mb-1">
                        {line.replace(/\*\*/g, "")}
                      </p>
                    );
                  }
                  if (line.startsWith("**") && line.includes(":**")) {
                    const [bold, ...rest] = line.split(":**");
                    return (
                      <p key={idx} className="mt-2">
                        <strong className="text-gray-700">{bold.replace("**", "")}:</strong>
                        {rest.join(":**")}
                      </p>
                    );
                  }
                  if (line.startsWith("— ")) {
                    return (
                      <div key={idx} className="flex items-start gap-2 mt-1.5">
                        <span className="text-[#007AFF] mt-0.5 shrink-0">—</span>
                        <span>{line.slice(2)}</span>
                      </div>
                    );
                  }
                  return line ? (
                    <p key={idx} className="mt-1.5">
                      {line}
                    </p>
                  ) : (
                    <div key={idx} className="h-1" />
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-gray-100 bg-[#f8fafd]">
        <div className="max-w-4xl mx-auto px-6 py-6 flex flex-wrap items-center justify-between gap-4">
          <p className="text-gray-400 text-xs">&copy; {new Date().getFullYear()} BroMoney. Все права защищены.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-gray-400 hover:text-[#007AFF] text-xs transition-colors cursor-pointer">
              Политика конфиденциальности
            </Link>
            <a href={`mailto:${contactEmail}`} className="text-gray-400 hover:text-[#007AFF] text-xs transition-colors cursor-pointer">
              {contactEmail}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
